import React from 'react';
import Profile from '../Profile';

const Pay = () => {
    return (
        <div>
            <p>comming Soon....</p>
            <Profile></Profile>
        </div>
    );
};

export default Pay;